export enum MenuPointUrl {
	DASHBOARD = '/dashboard',
	MAP_EDITOR = '/map-editor/editor',
	MAPS = '/map-editor/maps',
	AI_WORKFLOWS = '/ai-workflows',
	WORKFLOWS = '/workflows',
}
